import React, { useContext, useState } from "react";
import { UserContext } from "../../Context/ContextProvider";

const Profile = ({user, setUser}) => {
  const [ismenu, setIsMenu] = useState(false);
  const {gender,setGender}=useContext(UserContext);

  const handleLogout=()=>{
    setIsMenu(false);
    setUser('');
  }
  return (
    <>
      <div>
        <div
          className="cursor-pointer hover:text-slate-600 relative z-0 bg-gradient-to-r from-pink-500 px-[20px] py-[12px] items-center justify-center flex"
          onClick={() => {
            ismenu ? setIsMenu(false) : setIsMenu(true);
          }}
        >
          {
            gender==='male'?
            <img src={require('../../Images/maleProfile.png')} alt=""  className="h-[40px] rounded-[50%] mr-[8px]"/>:
            <img src={require('../../Images/femaleProfile.png')} alt="" className="h-[40px] rounded-[50%] mr-[8px]"/>
          }
          
         {user}
         </div>


<div className={`absolute z-10  right-[40vw] bg-white top-[65px] rounded-lg border-2 border-slate-300 text-black px-[20px] py-[12px] hover:bg-slate-100 cursor-pointer
              ${!ismenu? "hidden" : ""} 
            `} 
            onClick={handleLogout}
            >
            Logout
            </div>   
      </div>
    </>
  );
};

export default Profile;
